import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { ProfessionalAudience } from './components/ProfessionalAudience';
import { StatsBar } from './components/StatsBar';
import { Problems } from './components/Problems';
import { SessionMap } from './components/SessionMap';
import { Modules } from './components/Modules';
import { ModuleIncludes } from './components/ModuleIncludes';
import { Printables } from './components/Printables';
import { Comparison } from './components/Comparison';
import { Bonuses } from './components/Bonuses';
import { PricingPack } from './components/PricingPack';
import { Guarantee } from './components/Guarantee';
import { CostOfNotBuying } from './components/CostOfNotBuying';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
type MetaPixel = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: MetaPixel;
  loaded?: boolean;
  version?: string;
};
declare global {
  interface Window {
    fbq?: MetaPixel;
    _fbq?: MetaPixel;
  }
}

// Pixel «T-R-C IT» (portfolio Eureka_labs.Italia): vuoto finché il proprietario non lo crea.
// Non riutilizzare mai quello di un'altra offerta (Reiki IT, Costellazioni IT).
const META_PIXEL_ID = '';
export function App() {
  useEffect(() => {
    if (!META_PIXEL_ID) return;
    if (window.fbq) {
      window.fbq('track', 'PageView');
      return;
    }

    // Stessa coda del codice ufficiale di Meta: fbevents.js riprende le chiamate con callMethod.
    const fbq: MetaPixel = (...args: unknown[]) => {
      if (fbq.callMethod) fbq.callMethod(...args);else fbq.queue?.push(args);
    };
    fbq.push = fbq;
    fbq.queue = [];
    fbq.loaded = true;
    fbq.version = '2.0';
    window.fbq = fbq;
    window._fbq = fbq;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/it_IT/fbevents.js';
    document.head.appendChild(script);
    fbq('init', META_PIXEL_ID);
    fbq('track', 'PageView');
  }, []);
  return <main className="w-full overflow-x-hidden bg-mist font-sans text-navy antialiased" data-id="element-0" data-mp="3udayecxauv6t">
      <Hero data-id="element-1" data-mp="d4e4tqw8j8vn" />
      <ProfessionalAudience data-id="element-2" data-mp="d4xp3e9cy9cu" />
      <StatsBar data-id="element-3" data-mp="d45rxz0443kg" />
      <Problems data-id="element-4" data-mp="d2l9v8uzid3h" />
      <SessionMap data-id="element-5" data-mp="d2bfl92wpjrz" />
      <Modules data-id="element-6" data-mp="851kbcsu6dw8" />
      <ModuleIncludes data-id="element-7" data-mp="85b8qvy8gczt" />
      <Printables data-id="element-8" data-mp="864b7kq5sgc5" />
      <Comparison data-id="element-9" data-mp="83i1pfjpjqra" />
      <Bonuses data-id="element-10" data-mp="3gle90gn0mze4" />
      <PricingPack data-id="element-11" data-mp="3gkv01pfcflc8" />
      <Guarantee data-id="element-12" data-mp="3gmfu7dxqx29k" />
      <CostOfNotBuying data-id="element-13" data-mp="3glwb3twd07ty" />
      <FAQ data-id="element-14" data-mp="3gj1t090tiz3p" />
      <FinalCTA data-id="element-15" data-mp="3bmbfntgeehlz" />
      <Footer data-id="element-16" data-mp="3bmthd5ltxo1a" />
    </main>;
}